/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_SendInputs */

const cs_tasks_protocol_send = /** @type {(inputs: Tasks_Protocol_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat k podpisu`)
};

const en_tasks_protocol_send = /** @type {(inputs: Tasks_Protocol_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send for signing`)
};

/**
* | output |
* | --- |
* | "Send for signing" |
*
* @param {Tasks_Protocol_SendInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_send = /** @type {((inputs?: Tasks_Protocol_SendInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_SendInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_send(inputs)
	return cs_tasks_protocol_send(inputs)
});